import { mapEnumToOptions } from '@abp/ng.core';

export enum PrescriptionState {
  Active = 'Active',
  Expired = 'Expired',
  Complete = 'Complete',
}

export const prescriptionStateOptions = mapEnumToOptions(PrescriptionState);
